let mfaEntryGranted = false;

export const grantMfaEntry = () => {
	mfaEntryGranted = true;
};

export const isMfaEntryGranted = () => mfaEntryGranted;

export const revokeMfaEntry = () => {
	mfaEntryGranted = false;
};
